import type { HomepageGender, HomepageGoal } from "../homepage.types";
import { getJourneyForState, PREGNANCY_EXPLORING } from "./journeys";
import type {
  JourneyDefinition,
  JourneyViewerRole,
  Pathway,
  TreatmentModality,
} from "./plan.types";

/**
 * Resolve the journey used by Home's card stack.
 *
 * The legacy journey resolver still serves the Plan Builder, where an
 * incomplete state has its own compatibility entry. Home has a different
 * product contract: incomplete context is a neutral explorer surface and
 * must not inherit that legacy journey or a treatment modality.
 */
export function resolveHomepageJourney(
  gender: HomepageGender | null,
  goal: HomepageGoal | null,
  pathway: Pathway,
  modality?: TreatmentModality | null,
  viewerRole?: JourneyViewerRole | null,
): JourneyDefinition {
  if (!gender || !goal) {
    return PREGNANCY_EXPLORING;
  }

  return getJourneyForState(gender, goal, pathway, modality, viewerRole);
}
